// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ZO0Y8KqvnaI2xJ {\n  margin: 16px 8px 8px 8px;\n  display: flex;\n  align-items: baseline;\n}\n.ZO0Y8KqvnaI2xJ._2f2Xb6-OrwdqTu {\n  cursor: pointer;\n}\n.ZO0Y8KqvnaI2xJ ._2NBYCfXdjumjWm {\n  font-weight: bold;\n  white-space: pre-line;\n  line-height: 24px;\n  color: #172b4d;\n}\n.ZO0Y8KqvnaI2xJ ._2NBYCfXdjumjWm._1oDCv72AlGkY6w {\n  font-weight: normal;\n}\n.ZO0Y8KqvnaI2xJ .RntTMp64tme6Ku {\n  font-size: 12px;\n  line-height: 24px;\n}\n.ZO0Y8KqvnaI2xJ ._3DXrz36mu_Mcxa {\n  cursor: text;\n  white-space: pre;\n  margin: 0;\n  display: inline-block;\n}\n.ZO0Y8KqvnaI2xJ ._3um4MgFE5PAVcI {\n  align-self: flex-start;\n}\n.ZO0Y8KqvnaI2xJ .-stUKMvt22d3_D {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 8px;\n  height: 24px;\n  width: 24px;\n  line-height: 24px;\n  background: #DFE1E6;\n  overflow: hidden;\n  border-radius: 100%;\n}\n._2KaORDtdYxWz-8 {\n  font-size: 12px;\n  line-height: 24px;\n}\n._1DIHTcWOg3piby {\n  padding-bottom: 12px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"notificationMember": "ZO0Y8KqvnaI2xJ",
	"clickable": "_2f2Xb6-OrwdqTu",
	"memberName": "_2NBYCfXdjumjWm",
	"deletedMember": "_1oDCv72AlGkY6w",
	"memberReactors": "RntTMp64tme6Ku",
	"memberDate": "_3DXrz36mu_Mcxa",
	"avatarContainer": "_3um4MgFE5PAVcI",
	"avatar": "-stUKMvt22d3_D",
	"tooltipReactorNames": "_2KaORDtdYxWz-8",
	"profileCard": "_1DIHTcWOg3piby"
};
export default ___CSS_LOADER_EXPORT___;
